export const makeDropdownOnChangeEventObject=_ref=>{let value=_ref.value;return{target:{id:_ref.id,name:_ref.name,value:value}}};